import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Modal, Grid, TextField } from '@mui/material';
import { FormContainer, RowContainer, BaseLabel, Label, AutoComplete, cores } from '../../../styles/styleUtils'; // Reutilizando seus estilos
import ActionButtons from '../components/ActionButtons';
import ModalLoading from '../../ModalLoading';
import CampoMonetario from '../components/CampoMonetario';

const Style1 = styled(TextField)`
  width: 70%;
  border-radius: 10px;
  box-sizing: border-box;
  background-color: ${cores.branco};
  & .MuiInputBase-root {
    height: 36px;
    padding: 1.5px;
  }
`;

// Componente
const Conclusao = React.forwardRef((props, ref) => {
  const getInititalState = () => ({
    dataConclusao: props.proposta.dataConclusao || '',
    obsConclusao: props.proposta.obsConclusao || '',
  });
  const [formData, setFormData] = useState(getInititalState());
  const [modalLoading, setModalLoading] = useState(false);
  const [disableConfirm, setDisableConfirm] = useState(true);

  const handleDateChange = (newDate) => {
    setFormData((prev) => ({
      ...prev,
      dataConclusao: newDate,
    }));
  };

  // --- Handlers de Input ---
  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value,
    }));
  };

  // --- Lógica de Submissão ---

  const handleSubmit = async () => {
    props.onConfirm(formData);
    props.onClose();
  };

  const handleCancel = () => {
    if (window.confirm('Tem certeza que deseja sair? As alterações não salvas serão perdidas.')) {
      getInititalState();
      props.onClose();
    }
  };

  // --- Validação ---
  useEffect(() => {
    const { dataConclusao } = formData;
    // Validação básica: precisa de cliente e descrição
    if (dataConclusao) {
      setDisableConfirm(false);
    } else {
      setDisableConfirm(true);
    }
  }, [formData]);

  const formatToLocalInput = (dateInput) => {
    if (!dateInput) return '';
    const date = new Date(dateInput);

    // Verifica se a data é válida
    if (Number.isNaN(date.getTime())) return '';

    const offset = date.getTimezoneOffset() * 60000; // obtém o deslocamento em milissegundos
    const localDate = new Date(date.getTime() - offset); // ajusta para "falso UTC" que representa o horário local

    // Retorna no formato YYYY-MM-DDTHH:mm, removendo segundos e milissegundos
    return localDate.toISOString().slice(0, 16);
  };

  return (
    <Modal open={props.open} onClose={props.handleClose}>
      <FormContainer>
        <RowContainer>
          <Label htmlFor="cliente">Cliente</Label>
          <Style1 id="cliente" name="cliente" value={props.proposta.cliente.nome || null} disabled />
        </RowContainer>
        {/* --- Seção Detalhes da OS --- */}
        <Grid container spacing={2}>
          <Grid item xs={12} md={3}>
            <BaseLabel>Código</BaseLabel>
            <Style1
              name="codigo"
              value={props.proposta.codigo}
              sx={{ backgroundColor: cores.branco, borderRadius: 5 }}
              disabled
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <BaseLabel htmlFor="unidade">Unidade</BaseLabel>
            <Style1 id="unidade" value={props.proposta.unidade.nome || null} disabled />
          </Grid>
          <Grid item xs={12} md={3}>
            <BaseLabel>Cidade</BaseLabel>
            <Style1
              name="cidade"
              value={props.proposta.cliente?.cidade?.nome}
              fullWidth
              placeholder="Ex: Uberlândia"
              sx={{ backgroundColor: cores.branco, borderRadius: 5 }}
              disabled
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <BaseLabel>Telefone</BaseLabel>
            <Style1
              name="telefone"
              value={props.proposta.cliente?.telefone}
              fullWidth
              placeholder="(XX) XXXX-XXXX"
              // TODO: Adicionar máscara de telefone (ex: react-input-mask)
              sx={{ backgroundColor: cores.branco, borderRadius: 5 }}
              disabled
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <BaseLabel>Classificação</BaseLabel>
            <Style1 id="classificacao" value={props.proposta.classificacao.nome || null} disabled />
          </Grid>

          <Grid item xs={12} md={6}>
            <BaseLabel>Responsável</BaseLabel>
            <Style1 id="responsavelExecucao" value={props.proposta.responsavelExecucao.nome || null} disabled />
          </Grid>

          <Grid item xs={12} md={3}>
            <BaseLabel>Valor Custo</BaseLabel>
            <Style1
              name={'valorCusto'}
              value={props.proposta.valorCusto?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
              disabled
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <BaseLabel>Valor Serviços</BaseLabel>
            <Style1
              name={'valorCusto'}
              value={props.proposta.valorServico?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
              disabled
            />
          </Grid>
          <Grid item xs={12} md={3}>
            <BaseLabel>Valor OS</BaseLabel>
            <Style1
              name={'valorCusto'}
              value={props.proposta.valor?.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
              disabled
            />
          </Grid>
          

          <Grid item xs={12} md={6}>
            <BaseLabel>Data Conclusão</BaseLabel>
            <Style1
              type="datetime-local"
              name="dataConclusao"
              // Usamos a função auxiliar para garantir que o valor exibido seja o horário local correto
              value={formatToLocalInput(formData.dataConclusao)}
              onChange={(e) => handleDateChange(new Date(e.target.value))}
              fullWidth
              InputLabelProps={{ shrink: true }}
              sx={{ backgroundColor: cores.branco, borderRadius: 5 }}
            />
          </Grid>

          <Grid item xs={12}>
            <Label>Observação</Label>
            <TextField
              name="obsConclusao"
              value={formData.obsConclusao}
              onChange={handleInputChange}
              fullWidth
              multiline
              rows={4}
              placeholder="Observações..."
              sx={{ backgroundColor: cores.branco, borderRadius: 5 }}
            />
          </Grid>
        </Grid>
        {/* --- Botões de Ação --- */}
        <ActionButtons
          onCancel={handleCancel}
          onConfirm={handleSubmit}
          disableConfirm={disableConfirm}
          visualiza={props.visualiza}
        />
        {/* --- Modal de Loading --- */}
        {modalLoading && <ModalLoading open={modalLoading} />}
      </FormContainer>
    </Modal>
  );
});

export default Conclusao;